import React from 'react'
import { Button, Tooltip } from 'reactstrap'

class InfoButton extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            softTooltipOpen: false,
            hardTooltipOpen: false,
        }
    }

    toggleSoft() {
        this.setState({
            softTooltipOpen: !this.state.softTooltipOpen,
        })
    }

    toggleHard() {
        this.setState({
            softTooltipOpen: !this.state.hardTooltipOpen && this.state.softTooltipOpen,
            hardTooltipOpen: !this.state.hardTooltipOpen,
        })
    }

    render() {
        return <span>
            <Button
                size="sm"
                color="info"
                id={'Tooltip-' + this.props.id}
                onClick={() => {
                    this.toggleHard()
                }}
                style={{
                    'borderRadius': '256px',
                    'backgroundColor': '#40a0F0',
                    'width': '25px',
                    'height': '25px',
                    'margin': '0px',
                    'padding': '0px 0px 8px 0px',
                    ...this.props.style,
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-info-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
            </Button>
            <Tooltip
                isOpen={this.state.softTooltipOpen || this.state.hardTooltipOpen}
                target={'Tooltip-' + this.props.id}
                toggle={() => {this.toggleSoft()}}>

                {this.props.message || 'Empty tooltip.'}
            </Tooltip>
      </span>
    }
}

export { InfoButton }
